
import { FETCH_ANIMALS, CREATE_ANIMAL, UPDATE_ANIMAL, DELETE_ANIMAL,UPDATE_DEFAULT_ANIMAL } from '../actions';

const initialState = {
  selectedToDelete: null,
  selectedToEdit: null,
  setAnimalType: null,
  updateAnimalType: null,
  updateDefaultType: null,
  animalTypes: [],
  loading: false,
  selectedToDeleteError:null,
  animalTypesError:null,
  setAnimalTypeError:null,
  updateAnimalTypeError:null,
  updateDefaultTypeError:null
};

function addAnimalTypeReducer(state = initialState, action) {
  let selectedToDelete,
    animalTypes,
    setAnimalType,
    updateAnimalType,
    updateDefaultType;

  switch (action.type) {
    case `${UPDATE_DEFAULT_ANIMAL}_PENDING`:
    case `${UPDATE_ANIMAL}_PENDING`:
    case `${CREATE_ANIMAL}_PENDING`:
    case `${FETCH_ANIMALS}_PENDING`:
    case `${DELETE_ANIMAL}_PENDING`:
      return { ...state, loading: true,
        selectedToDeleteError:null,
        animalTypesError:null,
        setAnimalTypeError:null,
        updateAnimalTypeError:null,
        updateDefaultTypeError:null
      };

    case `${UPDATE_ANIMAL}_FULFILLED`:
      updateAnimalType = action.payload.data;
      return { ...state, loading: false, updateAnimalType };

    case `${UPDATE_DEFAULT_ANIMAL}_FULFILLED`:
      updateDefaultType = action.payload.data;
      return { ...state, loading: false, updateDefaultType };  

    case `${CREATE_ANIMAL}_FULFILLED`:
      setAnimalType = action.payload.data;
      return { ...state, loading: false, setAnimalType };

    case `${FETCH_ANIMALS}_FULFILLED`:
      animalTypes = action.payload.data;
      return { ...state, loading: false, animalTypes };

    case `${DELETE_ANIMAL}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${UPDATE_DEFAULT_ANIMAL}_REJECTED`:
      return {...state, loading: false, updateDefaultTypeError: action.payload.response.data, state: initialState };
    case `${UPDATE_ANIMAL}_REJECTED`:
      return {...state, loading: false, updateAnimalTypeError: action.payload.response.data, state: initialState };
    case `${CREATE_ANIMAL}_REJECTED`:
      return {...state, loading: false, setAnimalTypeError: action.payload.response.data, state: initialState };
    case `${FETCH_ANIMALS}_REJECTED`:
      return {...state, loading: false, animalTypesError: action.payload.response.data, state: initialState };
    case `${DELETE_ANIMAL}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };

    default:
      return state;
  }
}

export default addAnimalTypeReducer;
